import React, { useState } from 'react';
import { Segmented } from 'antd';
import MainLayout from '../layouts/MainLayout';
import ConsoleComponent from './console/ConsoleComponent';
import {
  CONSOLE_THEME_OPTIONS,
  getStoredConsoleTheme,
  setStoredConsoleTheme,
} from '../config/consoleThemes';

function ConsoleView() {
  const [theme, setTheme] = useState(getStoredConsoleTheme);

  return (
    <MainLayout menu='20'>
      <div style={{ marginBottom: 12 }}>
        <Segmented
          options={CONSOLE_THEME_OPTIONS}
          value={theme}
          onChange={(value) => {
            setTheme(value);
            setStoredConsoleTheme(value);
          }}
        />
      </div>
      <div style={{ height: 'calc(100vh - 220px)', minHeight: 420 }}>
        <ConsoleComponent theme={theme} />
      </div>
    </MainLayout>
  );
}

export default ConsoleView;
